import get from 'lodash/get'

const yandexMetrikaReachGoal = (targetName: string) => {
  if (
    typeof ym !== 'undefined' &&
    typeof Ya !== 'undefined' &&
    Ya &&
    typeof Ya._metrika !== 'undefined'
  ) {
    const counters = get(Ya._metrika.getCounters(), '[0].id')
    if (counters) {
      const counters = get(Ya._metrika.getCounters(), '[0].id')
      if (!counters) return

      if (!Array.isArray(counters)) ym(counters, 'reachGoal', targetName)
      else if (!counters.length) ym(counters[0], 'reachGoal', targetName)
      else counters.forEach((counter) => ym(counter, 'reachGoal', targetName))
    }
  }
}

export const analyticsReachGoal = (targetName: string) => {
  yandexMetrikaReachGoal(targetName)
}
